import React from "react";
import "./contact.css";

function Contact() {
    return(
        <div className="contactContainer">
            <br></br>
            <div className="contactText" data-aos="fade-up">
                Though I am no longer creating custom marquetry, existing artwork in stock can still be purchased.<br></br>
                I want to thank everyone who has supported me over the years.
            </div>
            <br></br>
            <div data-aos="fade-up">
                Charles Bingham<br></br>
                bing.inlay@gmail.com<br></br>
                269-964-6996<br></br>
            </div>
            <br></br>
            <div className="artistImageBox" data-aos="fade" data-aos-duration="3000">
                <img src="./images/chipNkim.jpg" alt="Artist and wife, Kim" className="artistImage" />
            </div>
            <br></br>
        </div>
    );
};

export default Contact;